import React, { useEffect, useRef, useState } from 'react'
import { a as three } from '@react-spring/three'
import { useGLTF } from '@react-three/drei'
import { useApartmentPreview, useMode } from '../../store'
import { useSpring } from '@react-spring/core'
import { isMobile } from 'react-device-detect'
import { useLocation } from 'wouter'

export default function ThreeBHKApartmentPreview(props) {
  const group = useRef()
  const { nodes, materials } = useGLTF('/glb/dollhouse/3BHKBPreExp.glb')
  const { setLottieState } = useApartmentPreview()
  const [location, setLocation] = useLocation()
  const [visibilityState, setVisibiilityState] = useState(false)

  const apartmentAnim = useSpring({
    scale: visibilityState
      ? isMobile
        ? [1.5, 1.5, 1.5]
        : [1, 1, 1]
      : [0, 0, 0],
    onRest: () => {
      if (visibilityState) {
        setLottieState(true)
      }
    },
  })

  useEffect(() => {
    props.modelLoaded()
  }, [nodes])

  useEffect(() => {
    if (props.visibility) {
      setVisibiilityState(true)
    } else {
      setVisibiilityState(false)
    }
  }, [props.visibility])

  if (location === `/${useMode.getState().name}/home`) {
    return (
      <three.group
        ref={group}
        {...props}
        dispose={null}
        scale={apartmentAnim.scale}
      >
        <mesh
          geometry={nodes['3BHKA_Preview'].geometry}
          material={materials['3BHKBPre']}
        />
      </three.group>
    )
  } else return null
}

useGLTF.preload('/glb/dollhouse/3BHKBPreExp.glb')
